import getRegExp, {
  asciiExtendedPattern,
} from 'jl-design-system/form/regex';

import GiftMessage from '../../../components/gift-message/GiftMessage';

const GIFT_MESSAGE = {
  component: GiftMessage,
  type: 'textarea',
  id: 'giftMessage',
  name: 'giftMessage',
  label: 'Add a gift message',
  props: {
    maxLines: 4,
    maxChars: 120,
    maxCharsLine: 30,
  },
  regex: getRegExp(asciiExtendedPattern),
  validationMessageKeys: {
    regex: 'Sorry, only plain text can be used for a gift message. Please remove any non standard characters.',
  },
};

export default GIFT_MESSAGE;
